export const errorMessages = {
  table_missing_selection: 'Cannot mass edit without a selected article.',
  upload_image_invalid_type: 'The provided file is not a valid image.',
  upload_image_heic_unreadable: 'This HEIC photo could not be converted. Export it as JPEG and try again.',
  upload_file_missing: 'No file was provided for upload.',
  upload_file_empty: 'The selected file is empty (0 bytes). Please check the file and try again.',
} as const;

export class ClientError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'ClientError';
  }
}
